import {Layout, Typography, Anchor} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import StakeholdersLogic from './StakeholdersLogic';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const StakeholdersPage = () => {
  const [backI, setBackI] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#HPBackground') {
      setBackI(appColors['ColorC']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#HPBackground' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorC'], fontSize: '2.5vh'}}>Introduction</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorC'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> S&nbsp;<br/> T&nbsp;<br/> A&nbsp;<br/> K&nbsp;<br/> E&nbsp;<br/> H&nbsp;<br/> O&nbsp;<br/> L&nbsp;<br/> D&nbsp;<br/> E&nbsp;<br/> R&nbsp;<br/> S&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='HPBackground'>
              <StakeholdersLogic/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default StakeholdersPage;
